// extracted by mini-css-extract-plugin
export default {"mainBlock":"mainBlock_mainBlock__Mj1pZ","mobile":"mainBlock_mobile__1idvJ"};